<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        created() {
            if (this.$root.env === 'frontend') {
                document.querySelector('.product_layout_3.love-map').classList.add('loaded')
            }
        },
    }
</script>

<style lang="scss">
    .leaflet-container {
        background: white !important;
    }

    #page_wrapper.sticky_header .content-area {
        padding-top: 207px;
    }

    .product_layout_3.love-map.loaded {
        opacity: 1;

    }

    .product_layout_3.love-map {

        #wccf_product_field_master_container {
            display: none !important;
        }

        .single_add_to_cart_button.button.alt,
        #woocommerce_single_product_summary.hmu-hook {
            display: none;
        }
    }

    .product_infos.fixed {
        display: none;
    }

    @media only screen and (max-width: 1023px) {
        .love-map.product_layout_3 .product_content_wrapper {
            margin-top: 0;
        }
        .lm-hide-for-medium {
            display: block;
        }
        .lm-show-for-large {
            display: none;
        }
    }

    @media only screen and (min-width: 1024px) {
        .lm-show-for-medium {
            display: none;
        }
        .lm-show-for-large {
            display: block;
        }
    }

    @media only screen and (max-width: 642px) {
        .lm-viewport {
            margin-top: 35px;
        }
    }
</style>